
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/auth",
      function () {
        return require("private-next-pages/account/auth.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/auth"])
      });
    }
  